export default __webpack_public_path__ + "assets/clock-component.af7b706e.svg";